module.exports = __webpack_public_path__ + "static/media/main13.f85b1efd.jpeg";